import { render, staticRenderFns } from "./PaddingRightIcon.vue?vue&type=template&id=73dd3756&"
import script from "./PaddingRightIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports